import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import ReactDOM from "react-dom/client"
import { routeTree } from "./routeTree.gen"

import { StrictMode } from "react"
import { OpenAPI } from "./client"
import { Toaster } from "./components/UI/toaster"
import { Provider } from "../src/components/UI/provider"
import { HelmetProvider } from "react-helmet-async"
import { SettingsProvider } from "./components/UI/settings-context"

const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT
OpenAPI.BASE = import.meta.env.VITE_API_URL

const queryClient = new QueryClient()

const router = createRouter({ routeTree })
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <>
    {ENVIRONMENT == "local" ? (
      <StrictMode>
        <Provider enableSystem={false}>
          <QueryClientProvider client={queryClient}>
            <SettingsProvider>
              <HelmetProvider>
                <RouterProvider router={router} />
                <Toaster />
              </HelmetProvider>
            </SettingsProvider>
          </QueryClientProvider>
        </Provider>
      </StrictMode>
    ) : (
      <Provider enableSystem={false}>
        <QueryClientProvider client={queryClient}>
          <SettingsProvider>
            <HelmetProvider>
              <RouterProvider router={router} />
              <Toaster />
            </HelmetProvider>
          </SettingsProvider>
        </QueryClientProvider>
      </Provider>
    )}
  </>
)
